import React from 'react';
import { motion } from 'framer-motion';
import { useNavigate } from 'react-router-dom';

const FinalCTA = () => {
  const navigate = useNavigate();

  return (
    <section className="w-full py-16 lg:py-24 px-6 flex justify-center bg-[#f8fafc] font-inter">
      {/* Conteneur Sombre "Idely Sized" */}
      <motion.div 
        initial={{ opacity: 0, y: 30 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true }}
        transition={{ duration: 0.8 }}
        className="max-w-[900px] w-full bg-[#1e3a5f] rounded-[32px] p-10 lg:p-16 relative overflow-hidden shadow-[0_30px_60px_-15px_rgba(30,58,95,0.3)]"
      >
        
        {/* EFFETS DE LUMIÈRE DISCRETS EN ARRIÈRE-PLAN */}
        <div className="absolute top-0 left-0 w-full h-full pointer-events-none">
          <div className="absolute top-[-20%] left-[-10%] w-[50%] h-[100%] bg-blue-400/10 rounded-full blur-[100px]" />
          <div className="absolute bottom-[-20%] right-[-10%] w-[50%] h-[100%] bg-blue-600/10 rounded-full blur-[100px]" />
        </div>

        {/* CONTENU TEXTUEL */}
        <div className="relative z-10 flex flex-col items-center text-center">
          <h2 className="text-white text-[28px] lg:text-[38px] font-[900] leading-tight mb-6 tracking-tight">
            Prêt à tester votre sécurité ?
          </h2>
          
          {/* Bloc de description avec fond semi-transparent */}
          <div className="bg-white/5 border border-white/10 rounded-2xl p-6 mb-10 max-w-[650px]">
            <p className="text-blue-100/80 text-[14px] lg:text-[16px] leading-relaxed font-medium">
              Nos experts sont à votre disposition pour une première évaluation gratuite de vos besoins en renseignement.
            </p>
          </div>
          
          {/* BOUTON BLANC (Réserver un pentest) */}
          <motion.button 
            onClick={() => navigate('/rdv')}
            whileHover={{ 
              scale: 1.05,
              boxShadow: "0 0 20px rgba(255, 255, 255, 0.3)" 
            }}
            whileTap={{ scale: 0.98 }}
            className="bg-white text-[#1e3a5f] px-10 py-4 rounded-xl font-black text-[15px] shadow-lg transition-all duration-300"
          >
            Réserver un pentest
          </motion.button>
        </div>

      </motion.div>
    </section>
  );
};

export default FinalCTA;
